
export const PaperStyle ={
    width: '283px', 
    display: 'flex', 
    alignItems: 'center', 
    boxShadow: 'none', 
    border: '1px solid #687B8E', 
    borderRadius: '8px'
}

export const SearchIconStyles = {
    paddingLeft:'12px',
    paddingTop:'5px',
    color: "#43586B"
}

export const InPutBaseStyle = {
    flex: '1', 
    padding: '0px', 
    border: 'none', 
    outline: 'none',
    fontFamily: "Plus Jakarta Sans",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "400",
    '& .MuiInputBase-input': {
        '&::placeholder': {
            color: '#000',
        },
    },
}

export const searchBoxStyle = {
  width: "263px",
  background: "#fff",
  borderRadius: "22px",
  border: "1px solid #EEE",
  fontFamily: "Plus Jakarta Sans",
  fontSize: "14px",
  color: "#222",
  boxShadow: "none",
  marginRight: "18px",
  marginBottom: "0px",
  "& .MuiInputBase-input": {
    fontFamily: "Plus Jakarta Sans",
    fontSize: "15px",
    padding: "12px 0px",
    paddingLeft: "2px"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none"
  }
}